export enum ExtendedSettingsMode {
  None = 'NONE',
  ProcessorLevel = 'PROCESSOR_LEVEL',
  ContracLevel = 'CONTRACT_LEVEL',
}
